<template lang="pug">
#selecionar-territorio
    .fields
        el-select(
            v-model='dados.camada',
            :placeholder='$t("laudos.selecioneCamada")',
            :loading='carregandoListas',
            filterable
        )
            el-option(
                v-for='(camada, index) in camadas',
                :key='`selecionar-camada-${index}`',
                :label='camada.nome',
                :value='camada.id'
            )
        el-select(
            v-model='dados.safraId',
            :loading='carregandoListas',
            :placeholder='$t("laudos.selecioneSafra")',
            filterable
        )
            el-option(
                v-for='(safra, index) in safras',
                :key='`selecionar-safra-${index}`',
                :label='safra.safraAno',
                :value='safra.id'
            )
        el-select(
            v-model='dados.culturaId',
            :loading='carregandoListas',
            :placeholder='$t("laudos.selecionaCultura")',
            filterable
        )
            el-option(
                v-for='(item, index) in culturas',
                :key='`${item.codigo}-${index}`',
                :label='item.nome',
                :value='item.id'
            )
        .obersvacao
            el-input.textarea(
                v-model='dados.observacao',
                :placeholder='$t("laudos.observacao")',
                type='textarea',
                :maxlength='500',
                resize='none'
            )
            span.length {{ dados.observacao.length }}/500
    p.mt-2 {{ $t('laudos.selecioneUmOuMaisTerritoriosParaSolicitacaoDeLaudos') }}
    el-input.mb-3(
        :placeholder='$t("laudos.procurePorUmTerritorioCarOuPessoaVinculada")',
        prefix-icon='el-icon-search',
        v-model='filtroSelecionarTerritorio',
        @input='debounceObterTerritorio',
        @keyup.native.enter='findAllTerritoriosSimplificado'
    )
    aviso-selecionar-territorio(:tipoLaudo='tipoLaudo')
    .conteudo(v-if='!existeRetornoSimplificadoCar')
        el-table(
            :data='territorios',
            border,
            style='width: 100%',
            @selection-change='alterarSelecao',
            row-key='id'
        )
            el-table-column(
                align='center',
                type='selection',
                :reserve-selection='true',
                :selectable='canSelectRow'
            )

            el-table-column(prop='nome', :label='$t("laudos.territorio")')
                template(v-slot:default='{ row }')
                    p.m-0
                        b {{ row.nome }}
                        i.el-icon-info.enabled-icon.mx-2(
                            v-if='laudoComRestricaoTamanhoArea(row)',
                            slot='suffix',
                            :title='`${$t("laudos.erro.areaMaiorQueLimite")} ${$t("laudos.erro.suporteEmail")}`'
                        )

    .py-3(style='text-align: right', v-if='!existeRetornoSimplificadoCar')
        el-pagination(
            :pager-count='5',
            :page-size='pageParams.size',
            :current-page.sync='pageParams.page',
            layout='prev, pager, next',
            :total='totalTerritorios',
            @current-change='findAllTerritoriosSimplificado'
        )
    .sem-resultado(v-if='existeRetornoSimplificadoCar')
        .msg-geral
            .i.mdi.mdi-close-circle.mr-2(
                style='color: #740f0f; font-size: 18px'
            )
            .alerta-error {{ $t('laudos.naoFoiPossivelEncontrarInformacaoInserida') }}
                br
                | {{ $t('laudos.carNaoVinculadoAoTerritorioParaPoderSolicitarLaudo') }}
                br
                | {{ $t('laudos.elegibilidadeRenovabio') }}.

        p {{ $t('laudos.desejaCadastrarUmNovoTerritorio') }}?
            .botao.marginButton(slot='footer')
                el-button(
                    icon='el-icon-circle-plus-outline',
                    type='primary',
                    size='small',
                    @click='cadastrarTerritorio',
                    style='width: 100%'
                )
                    | {{ $t('laudos.cadastrarTerritorio') }}
    el-divider.custom-divider
    .footer(slot='footer')
        BaseButton(type='outline', @click='cancelarModal') {{ $t('mensagens.comuns.cancelar') }}
        BaseButton(
            type='primary',
            @click='enviarTerritoriosSelecionados',
            :disabled='isValid'
        ) {{ $t('mensagens.comuns.continuar') }}
</template>

<script>
import TerritorioService from '@/services/TerritorioService';
import formatters from '@/modules/laudos/utils/formatters';
import { ordem } from '@/utils/ordenacao';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import BaseButton from '@/modules/laudos/components/BaseButton.vue';
import AvisoSelecionarTerritorio from '@/modules/laudos/components/AvisoSelecionarTerritorio.vue';

export default {
    name: 'SelecionarTerritorio',
    emits: ['cancelar-modal', 'getTerritoriosSelecionados'],
    components: {
        BaseButton,
        AvisoSelecionarTerritorio
    },
    props: {
        selecionados: {
            type: Array,
            default() {
                return [];
            }
        },
        tipoLaudo: {
            type: Number,
            required: true
        },
        camadas: {
            type: Array,
            required: true
        },
        safras: {
            type: Array,
            required: true
        },
        culturas: {
            type: Array,
            required: true
        },
        carregandoListas: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            filtroSelecionarTerritorio: '',
            territorios: [],
            territoriosSelecionados: [],
            selectedIds: [],
            checkAll: false,
            isIndeterminate: false,
            timeDebounce: null,
            pageParams: {
                page: 1,
                size: 8
            },
            dados: {
                observacao: '',
                safraId: '',
                camada: '',
                culturaId: ''
            },
            totalTerritorios: 0,
            existeRetornoSimplificadoCar: false,
            tiposLaudosCarObrigatorio: [
                TipoLaudo.AVALIACAO_SOCIOAMBIENTAL,
                TipoLaudo.DINAMICA_EXPLORACAO,
                TipoLaudo.SUPRESSAO_VEGETAL_RED_YELLOW_FLAG,
                TipoLaudo.CARBONO,
                TipoLaudo.CONFORMIDADE,
                TipoLaudo.RENOVABIO
            ],
            tiposLaudosAreaMaximaPermitida: [TipoLaudo.CROQUI_LOCALIZACAO],
            areaMaximaPermitida: 150000
        };
    },
    computed: {
        isValid() {
            const camada = !this.dados.camada;
            const safraId = !this.dados.safraId;
            const selectedIds = !this.selectedIds.length;
            const culturaId = !this.dados.culturaId;

            return selectedIds || camada || safraId || culturaId;
        }
    },
    mounted() {
        this.ajustarJaSelecionados();

        window.addEventListener('keydown', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        });
    },

    methods: {
        debounceObterTerritorio() {
            this.pageParams.page = 1;
            clearTimeout(this.timeDebounce);
            this.timeDebounce = setTimeout(() => {
                this.findAllTerritoriosSimplificado();
            }, 1500);
        },
        canSelectRow(row) {
            return (
                row.totalCARs !== 0 && !this.laudoComRestricaoTamanhoArea(row)
            );
        },
        alterarSelecao(rows) {
            this.territoriosSelecionados = rows;
            this.selectedIds = rows.map(row => row.id);
        },
        getFiltroSelecionarTerritorio() {
            if (this.filtroSelecionarTerritorio) {
                const cpfCnpj = formatters.documentoFormatToNumeral(
                    this.filtroSelecionarTerritorio
                );

                return cpfCnpj === ''
                    ? this.filtroSelecionarTerritorio
                    : cpfCnpj;
            }
            return '';
        },

        async findAllTerritoriosSimplificado() {
            try {
                const filtro = {
                    size: this.pageParams.size,
                    page: this.pageParams.page - 1
                };
                const { data } =
                    await TerritorioService.findAllSimplificadoPaginado(
                        filtro,
                        this.getFiltroSelecionarTerritorio()
                    );
                this.territorios = data.content;
                this.totalTerritorios = data.totalElements;
                this.existeRetornoSimplificadoCar = false;
                this.organizar();
            } catch (err) {
                this.$notify.error({
                    message: this.$t('laudos.ocorreuUmErroAoBuscarTerritorios')
                });
            }
        },

        organizar() {
            if (!this.territorios) {
                return;
            }

            this.territorios.sort((a, b) => ordem(a, b));
        },

        enviarTerritoriosSelecionados() {
            const dados = {
                territoriosSelecionados: this.territoriosSelecionados,
                observacao: this.dados.observacao,
                safraId: this.dados.safraId,
                camadaId: this.dados.camada,
                culturaId: this.dados.culturaId,
                tipoLaudoId: this.tipoLaudo
            };
            this.$emit('getTerritoriosSelecionados', dados);
        },

        ajustarJaSelecionados() {
            this.selectedIds = this.selecionados.map(({ id }) => id);
            this.findAllTerritoriosSimplificado();
        },

        laudoComRestricaoTamanhoArea(territorio) {
            return (
                territorio.areaHa > this.areaMaximaPermitida &&
                this.tiposLaudosAreaMaximaPermitida.includes(this.tipoLaudo)
            );
        },

        cancelarModal() {
            this.$emit('cancelar-modal');
        }
    }
};
</script>

<style lang="scss" scoped>
#selecionar-territorio {
    .fields {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        .el-select {
            width: 50%;
        }
        .obersvacao {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            width: 50%;
            gap: 4px;
            .textarea {
                width: 100%;
            }
            .length {
                font-size: 12px;
                color: var(--primary);
            }
        }
    }
    .footer {
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
    }
    .conteudo {
        min-height: 33vh;
        max-height: 60vh;
        overflow-y: auto;
    }

    .custom-divider {
        margin-bottom: 10px;
        margin-top: 0px;
    }

    .msg-geral {
        border-radius: 5px;
        padding: 14px 5px;
        font-weight: 500;
        margin-bottom: 13px;
        border: 1px solid #de1a1a;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .alerta-error {
        margin: 5px 10px 5px 10px;
        max-width: 90%;
        text-align: left;
    }
}
</style>
